import {
  ADDRESS_CEP,
  ADDRESS_LINE_1,
  ADDRESS_LINE_2,
  CNPJ,
  COMPANY_NAME,
  EMAIL,
  LOGO_URL,
} from '@/lib/constants'
import WhatsAppButton from '@/components/WhatsAppButton'

function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="bg-slate-950 border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-12 sm:py-14">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-10">
          <div className="flex items-start gap-4">
            <div className="bg-white rounded-xl p-2.5 shrink-0">
              <img
                src={LOGO_URL}
                alt={COMPANY_NAME}
                className="h-7 w-auto object-contain"
              />
            </div>
            <div>
              <p className="text-white text-sm font-semibold tracking-tight">{COMPANY_NAME}</p>
              <p className="text-white/50 text-xs mt-1">CNPJ {CNPJ}</p>
              <p className="text-white/50 text-xs mt-3 leading-relaxed">
                {ADDRESS_LINE_1}
                <br />
                {ADDRESS_LINE_2}
                <br />
                CEP {ADDRESS_CEP}
              </p>
              <a
                href={`mailto:${EMAIL}`}
                className="inline-block text-white/70 text-xs mt-3 hover:text-white transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 rounded-sm"
              >
                {EMAIL}
              </a>
            </div>
          </div>
          <WhatsAppButton label="Falar no WhatsApp" variant="outline" size="md" />
        </div>
        <div className="mt-14 pt-8 border-t border-white/10">
          <p className="text-white/40 text-xs text-center sm:text-left">
            © {year} {COMPANY_NAME}. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
